// Sound effects using Web Audio API
export const playSound = (type) => {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  switch (type) {
    case 'success':
      oscillator.frequency.value = 523.25; // C5
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);

      setTimeout(() => {
        const osc2 = audioContext.createOscillator();
        const gain2 = audioContext.createGain();
        osc2.connect(gain2);
        gain2.connect(audioContext.destination);
        osc2.frequency.value = 659.25; // E5
        osc2.type = 'sine';
        gain2.gain.setValueAtTime(0.3, audioContext.currentTime);
        gain2.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
        osc2.start(audioContext.currentTime);
        osc2.stop(audioContext.currentTime + 0.5);
      }, 150);
      break;

    case 'error':
      oscillator.frequency.value = 200;
      oscillator.type = 'sawtooth';
      gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.3);
      break;

    case 'click':
      oscillator.frequency.value = 800;
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1);
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.1);
      break;

    default:
      break;
  }
};

// Text-to-speech for exercises
export const speak = (text, lang = 'fr-FR') => {
  console.log('🔊 speak() called with:', text);
  if ('speechSynthesis' in window) {
    // Annuler toute synthèse en cours
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang;
    utterance.rate = 0.8;
    utterance.pitch = 1.2;

    utterance.onstart = () => {
      console.log('✅ Speech started:', text);
    };

    utterance.onerror = (event) => {
      console.error('❌ Speech error:', event);
    };

    utterance.onend = () => {
      console.log('✅ Speech ended');
    };

    // Fonction pour sélectionner une voix féminine
    const selectFemaleVoice = () => {
      const voices = window.speechSynthesis.getVoices();
      console.log('🎤 Available voices:', voices.length);

      // Chercher une voix féminine française
      const femaleVoice = voices.find(voice =>
        voice.lang.startsWith('fr') &&
        (voice.name.toLowerCase().includes('female') ||
         voice.name.toLowerCase().includes('femme') ||
         voice.name.toLowerCase().includes('amélie') ||
         voice.name.toLowerCase().includes('virginie') ||
         voice.name.toLowerCase().includes('pauline') ||
         voice.name.includes('Google français'))
      );

      if (femaleVoice) {
        console.log('✅ Using female voice:', femaleVoice.name);
        utterance.voice = femaleVoice;
      } else {
        console.log('⚠️ No female voice found, using default');
      }

      console.log('🔊 Calling speechSynthesis.speak()');
      window.speechSynthesis.speak(utterance);
    };

    // Si les voix sont déjà chargées
    if (window.speechSynthesis.getVoices().length > 0) {
      selectFemaleVoice();
    } else {
      // Sinon, attendre qu'elles soient chargées
      console.log('⏳ Waiting for voices to load...');
      window.speechSynthesis.addEventListener('voiceschanged', selectFemaleVoice, { once: true });
    }
  } else {
    console.error('❌ speechSynthesis not supported');
  }
};
